module.exports = __webpack_public_path__ + "img/16.751e4396.png";